import barba from '@barba/core'
import PageState from './page-state'



const pageStateProp = 'page-subset'



/**
 * Class with static method open(), to initiate
 * transition to and HTML subset within the page.
 */
class PageSubset {
    static open(id, state = {}) {
        const href = barba.data.current.url.href
        // Programmatic navigation. This trigger name 
        // is important for compatibility with "PageState"
        const trigger = 'pagesubset' 
        // Indicate that we will transition to the same page
        const self = true
        // Alter Barba.JS history
        barba.history.add(href, trigger)
        // Change window history with PageState
        PageState.empty()
        PageState.set(pageStateProp, id)
        // Additionnal page state date
        for (const [key, value] of Object.entries(state)) {
            PageState.set(key, value)
        }
        // Transition to the same page
        barba.page(href, trigger, self)
    }
}



/**
 * Transform a Barba.JS page container to replace it's HTML
 * with it's subset <template> content.
 */
function applySubsetHtml(container) {
    const id = PageState.get(pageStateProp)
    if (!id || typeof id !== 'string') {
        return
    }
    const template = container.querySelector(`template#${id}`)
    if (!template) {
        return
    }
    const node = document.importNode(template.content, true)
    container.innerHTML = ""
    container.append(node)
}



/**
 * On page load, rework the HTML to display the subset.
 */

applySubsetHtml(document.querySelector('[data-barba="container"]'))



/**
 * When the next container is added, rework the HTML to display the subset.
 */
barba.hooks.nextAdded(({ next }) => applySubsetHtml(next.container))



/**
 * Listen on document for click on element with
 * [data-page-subset="id"]
 */
document.addEventListener('click', e => {
    const node = e.target.closest('[data-page-subset]')
    if (!node || !node.dataset.pageSubset) {
        return
    }
    PageSubset.open(node.dataset.pageSubset)
    e.preventDefault()
})



export { PageSubset }
export default PageSubset
